<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemToSave.bareme_libelle}}
    </h4>
    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body">
    <ng-container>

        <mat-tab-group mat-align-tabs="start" #tabGroup (selectedIndexChange)="selectedChangeValue($event)"
            [(selectedIndex)]="indiceTab">
            <mat-tab label="DEFINITION">
                <div *ngIf="indiceTab == 0" style="overflow-x: hidden">
                    <div class="row">
                        <form class="m-1">
                            <strong class="section-title">Entete barème</strong>
                            <app-detail-entete-bareme 
                            [bareme_id]="itemToSave.bareme_id"></app-detail-entete-bareme>
                            <hr>
                            <strong class="section-title">Détail</strong>
                            <app-detail-produit-bareme [bareme_id]="itemToSave.bareme_id"
                                ></app-detail-produit-bareme>
                        </form>

                    </div>
                </div>
            </mat-tab>
            <mat-tab label="GARANTIES">
                <div *ngIf="indiceTab == 1" style="overflow-x: hidden">
                    <app-detail-garantie-bareme [bareme_id]="itemToSave.bareme_id"
                        ></app-detail-garantie-bareme>

                </div>
            </mat-tab>
            <mat-tab label="ACTES">
                <div *ngIf="indiceTab == 2" style="overflow-x: hidden">
                    <app-detail-actes-bareme [bareme_id]="itemToSave.bareme_id"
                        ></app-detail-actes-bareme>

                </div>
            </mat-tab>
        </mat-tab-group>


    </ng-container>
</div>

<div class="modal-footer modal-footer-custom" *ngIf="indiceTab == 0">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>